import { phase1ThoughtSummary } from './phase1ThoughtSummary'

export function patchAssistant(ctx, patch) {
  const { tid, pendingId, setMessagesByThreadId } = ctx
  setMessagesByThreadId((prev) => {
    const list = [...(prev[tid] ?? [])]
    const index = list.findIndex((message) => message.id === pendingId)
    if (index === -1) return prev

    const current = list[index]
    const nextPatch = typeof patch === 'function' ? patch(current) : patch
    const next = [...list]
    next[index] = { ...current, ...nextPatch, phase1: true, createdAt: Date.now() }
    return { ...prev, [tid]: next }
  })
}

export function patchFromRun(ctx, run, extra = {}) {
  patchAssistant(ctx, (current) => ({
    text: run.text || (run.status === 'streaming' ? '' : current.text),
    responseParts: run.responseParts,
    blocks: run.blocks,
    activity: run.activity,
    workStatus: run.workStatus,
    publicTimeline: run.publicTimeline,
    citations: run.citations,
    memoryIds: run.memoryIds,
    phase1RunId: run.runId,
    phase1MessageId: run.assistantMessageId || (run.status === 'done' ? run.messageId : current.phase1MessageId),
    phase1Mock: run.mock,
    demoStreamActive: run.status === 'streaming',
    thoughtSummary: phase1ThoughtSummary(run),
    ...extra,
  }))
}
